/**
 * Агенти за підпискою (ADR-0011): the first section of the Agents screen and the «Агенти» block of
 * «Огляд». Mockup `docs/mockups/phase-3/agents.html`. Steps are mapped to literal keys in the page
 * (see the note in `agents.ts`).
 */
export const skillAgents = {
  'agents.section.skill': 'За підпискою',
  'skillAgents.intro': 'Агенти, що працюють як скіли Claude за вашою підпискою. Їхня робота — задачі в Офісі, знання беруть зі «Знань», питання до вас — у «Чекають мене».',
  'skillAgents.empty': 'Агентів за підпискою ще немає.',
  'skillAgents.col.agent': 'Агент',
  'skillAgents.col.step': 'Крок',
  'skillAgents.col.status': 'Стан',
  'skillAgents.col.lastRun': 'Останній запуск',
  'skillAgents.col.tasks': 'Задачі',
  'skillAgents.col.questions': 'Питання',
  'skillAgents.status.learning': 'вчиться',
  'skillAgents.status.working': 'працює',
  'skillAgents.status.paused': 'на паузі',
  'skillAgents.outcome.done': 'зроблено',
  'skillAgents.outcome.needs_human': 'чекає вас',
  'skillAgents.outcome.nothing': 'не було задач',
  'skillAgents.outcome.failed': 'збій',
  'skillAgents.neverRan': 'ще не запускався',
  'skillAgents.skillVersion': 'скіл {version}',
  'skillAgents.noSkill': 'скіла ще немає',
  'skillAgents.step': 'Крок {n}: {name}',
  'skillAgents.step.0': 'роль і межі',
  'skillAgents.step.1': 'інвентар матеріалів',
  'skillAgents.step.2': 'транскрипція',
  'skillAgents.step.3': 'витяжки',
  'skillAgents.step.4': 'зведення в довідку',
  'skillAgents.step.5': 'еталони',
  'skillAgents.step.6': 'скіл 0.1',
  'skillAgents.step.7': 'тестовий прогін',
  'skillAgents.step.8': 'оцінка прогону',
  'skillAgents.step.9': 'правка скіла',
  'skillAgents.step.10': 'встановлення',
  'skillAgents.step.11': 'робота',
  'skillAgents.card.role': 'Роль',
  'skillAgents.card.business': 'Бізнес',
  'skillAgents.card.folder': 'Папка',
  'skillAgents.card.pools': 'Вчиться з',
  'skillAgents.card.tags': 'Мітки знань',
  'skillAgents.card.model': 'Модель',
  'skillAgents.card.schedule': 'Коли працює',
  'skillAgents.card.note': 'Чекає',
  'skillAgents.card.tasks': 'Задачі агента',
  'skillAgents.card.questions': 'Питання до вас',
  'skillAgents.card.runs': 'Запуски',
  'skillAgents.card.noTasks': 'Відкритих задач немає.',
  'skillAgents.card.noQuestions': 'Питань немає.',
  'skillAgents.card.noRuns': 'Запусків ще не було.',
  'skillAgents.card.dialog': 'розмова',
  'skillAgents.card.close': 'Закрити',
  'skillAgents.card.extracts': 'Витяжки в «Знаннях»',
  'overview.agents.title': 'Агенти',
  'overview.agents.none': 'Агентів за підпискою ще немає.',
  'overview.agents.on': 'зараз {key}:',
  'overview.agents.idle': 'відкритих задач немає',
  'overview.agents.questions': 'питань до вас: {n}',
  'overview.agents.last': 'останній запуск {when}: {outcome}',
  'overview.waiting.fromAgent': 'від агента «{title}»',
} as const;
